import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 144px)',
      overflow: 'auto',
      overflowX: 'hidden',
    },
    root1: {
      height: 'calc(100vh - 194px)',
      overflow: 'auto',
      overflowX: 'hidden',
    },
    card: {
      padding: '16px',
      borderRadius: 0,
    },
    submitInspectionTextGrid: {
      '& .submitInspectionText': {
        fontWeight: 700,
        color: MaterialPalette.common.black,
        letterSpacing: '1.25px',
        marginLeft: '8px',
      },
    },
    buttonTextGrid: {
      '& .buttonText': {
        letterSpacing: '1.25px',
        fontWeight: 700,
      },
    },
    checkBoxText: {
      flex: 'inherit',
      marginLeft: '24px',
      marginTop: '-4px',
      '& .subtitle': {
        fontSize: '14px',
        fontWeight: 600,
        color: '#707070',
        fontStyle: 'normal',
        lineHeight: '20px',
      },
    },
    subtitleGrid: {
      '& .subtitle': {
        fontSize: '14px',
        fontWeight: 600,
        color: '#707070',
        fontStyle: 'normal',
        lineHeight: '20px',
      },
    },
    accordianContainer: {
      margin: '8px',
      borderRadius: '8px',
    },
    signAndStampTitle: {
      fontSize: '25px',
      fontWeight: 300,
    },
    cancelButtonGrid: {
      marginRight: '4px',
      border: '1px solid rgba(42, 171, 63, 1)',
      borderRadius: '4px',
      height: 44,
      '& .cancelButton': {
        border: '1px solid rgba(42, 171, 63, 1)',
        borderRadius: '4px',
        height: 42,
        display: '',
      },
      '& .cancelButtonHide': {
        border: '1px solid rgba(42, 171, 63, 1)',
        borderRadius: '4px',
        height: 44,
        display: 'none',
      },
    },
    cancelButtonGridHide: {
      display: 'none',
    },
    ciAccordianGrid: {
      '& .cardView': {
        background: 'rgba(255,255,255,0.05)',
        margin: '8px',
        marginBottom: '0px',
      },
      '& .card1': {
        background: 'none',
        margin: '-40px -20px',
        boxShadow: 'none',
      },
      '& .card2': {
        marginTop: '8px',
      },
    },
    preivousCommentBox: {
      borderRadius: '4px',
    },
    submitInspectionGrid: {
      padding: '16px 16px 0px 16px',
      '& .submitInspectionTitle': {
        fontSize: 30,
        fontWeight: 300,
      },
    },
    hideCompleteInspection: {
      display: 'none',
    },
    showCompleteInspection: {
      display: '',
    },
    submitInsButtonGrid: {
      '& .submitInsButtonDisabled': {
        backgroundColor: 'rgba(255, 255, 255, 0.5) !important',
        borderRadius: '4px',
      },
      '& .submitInsButtonEnabled': {
        backgroundColor: 'rgba(42, 171, 63, 1)',
        borderRadius: '4px',
      },
    },
    completeInsInnerGrid: {
      '& .completeInsInnerCard': {
        margin: '8px 16px 22px',
        padding: '24px 24px 22px',
      },
    },
    recommendationsLabel: {
      paddingBottom: 5,
    },
    textFieldGrid: {
      '& .recommendationTextEnabled': {
        border: '1px solid rgba(255, 255, 255, 0.6)',
        borderRadius: '4px',
        height: '100px',
        backgroundColor: '#1e1e1e',
      },
      '& .recommendationTextDisabled': {
        border: '',
        borderRadius: '4px',
        height: '100px',
        backgroundColor: '',
      },
      '& .recommendationsLabelDisabled': {
        paddingBottom: 5,
        color: 'rgba(255, 255, 255, 0.38)',
      },
    },
    completionDateGrid: {
      marginTop: 32,
      '& .completioDateLabel': {
        paddingBottom: '5px',
      },
      '& .completioDateLabelDisabled': {
        paddingBottom: '5px',
        color: 'rgba(255, 255, 255, 0.38)',
      },
    },
    recommandationSaveButtonGrid: {
      '& #recommandationSaveButton': {
        border: '1px solid rgba(255, 255, 255, 0.4)',
        borderRadius: '4px',
        height: 44,
      },
      '& #recommandationSaveButtonDisabled': {
        border: '1px solid rgba(42, 171, 63, 1)',
        borderRadius: '4px',
        height: 44,
      },
    },
    commentsGrid: {
      padding: '16px 16px 8px',
      '& .commentsLabel': {
        fontSize: '30px',
        fontWeight: 300,
      },
    },
    liCommentsGrid: {
      '& .liCommentsCard': {
        margin: '8px 16px 22px',
        padding: '24px 24px 22px',
      },
    },
    leadInspectorCommentsLabel: {
      paddingBottom: '5px',
    },
    commentsTextField: {
      borderRadius: '4px',
      height: '100px',
    },
    fiCommentsLabel: {
      paddingBottom: '5px',
    },
    fiCommentsTextField: {
      borderRadius: '4px',
      height: '100px',
    },
    previousCommentsLabelGrid: {
      '& .previousCommentsLabel': {
        paddingBottom: '5px',
        color: 'rgba(239, 239, 239, 0.5)',
        marginTop: '32px',
        letterSpacing: '0.55px',
        lineHeight: '20px',
      },
    },
    dateTimeGrid: {
      '& .dateTimeText': {
        paddingBottom: '5px',
        color: 'rgba(239, 239, 239, 0.5)',
        marginTop: '16px',
        letterSpacing: '0.55px',
        lineHeight: '20px',
      },
    },
    accordianGrid: {
      '& .accordianTitle': {
        marginLeft: '5px',
        fontSize: '30px',
        fontWeight: 300,
      },
    },
    confirmationForCIGrid: {
      padding: '25px 0px 25px 0px',
      '& .confirmationForCIContent': {
        width: '100%',
        fontSize: 16,
        fontWeight: 300,
        letterSpacing: '0.15px',
        color: 'rgba(255, 255, 255, 0.87)',
      },
    },
    dialogActionButtonGrid: {
      float: 'right',
      marginLeft: 'auto',
      '& .buttonText': {
        letterSpacing: '1.25px',
        fontWeight: 700,
      },
    },
    confirmationForPMCheclist: {
      padding: '25px 0px 25px 0px',
      '& .confirmationForPMChecklistContent': {
        width: '100%',
        fontSize: 16,
        fontWeight: 300,
        letterSpacing: '0.15px',
        color: 'rgba(255, 255, 255, 0.87)',
      },
    },
    assignBackButtonGrid: {
      border: '1px solid rgba(42, 171, 63, 1)',
      borderRadius: '4px',
      height: 44,
      marginRight: 10,
      '& .assignBackButton': {
        border: '1px solid rgba(42, 171, 63, 1)',
        borderRadius: '4px',
        height: 42,
      },
    },
    submitReviewButtonGrid: {
      '& #submitReviewButtonDisabled': {
        backgroundColor: 'rgba(255, 255, 255, 0.48)',
        borderRadius: '4px',
      },
      '& #submitReviewButton': {
        backgroundColor: '',
        borderRadius: '4px',
      },
    },
    saveCommentButtonGrid: {
      '& .saveCommentButton': {
        borderRadius: '4px',
        display: '',
      },
      '& .saveCommentButtonHide': {
        borderRadius: '4px',
        display: 'none',
      },
      '& #saveCommentButtonBg': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      },
      '& #saveCommentButtonNoBg': {
        backgroundColor: '',
      },
    },
    inspectedBy: {
      marginLeft: '20px !important',
      marginTop: '10px !important',
      display: 'flex',
      cursor: 'pointer',
    },
  }),
);

export default useStyles;
export { useStyles };
